var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84314 0C1.27281 0 0 1.27281 0 2.84314C0 4.41346 1.27281 5.68628 2.84314 5.68628H41.5098C43.0801 5.68628 44.3529 4.41346 44.3529 2.84314C44.3529 1.27281 43.0801 0 41.5098 0H2.84314ZM2.84314 16.4902C1.27281 16.4902 0 17.763 0 19.3333C0 20.9037 1.27281 22.1765 2.84314 22.1765H41.5098C43.0801 22.1765 44.3529 20.9037 44.3529 19.3333C44.3529 17.763 43.0801 16.4902 41.5098 16.4902H2.84314ZM2.84314 32.9804C1.27281 32.9804 0 34.2532 0 35.8235C0 37.3939 1.27281 38.6667 2.84314 38.6667H41.5098C43.0801 38.6667 44.3529 37.3939 44.3529 35.8235C44.3529 34.2532 43.0801 32.9804 41.5098 32.9804H2.84314Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuIcon);
export default __webpack_public_path__ + "static/media/hamburger-menu-icon.6e65e4b1fc809abda333c97107a0f923.svg";
export { ForwardRef as ReactComponent };